import { Component, WritableSignal } from '@angular/core';
import { ToastService } from 'src/app/services/ui/toast/toast.service';
import { SpinnerComponent } from "../spinner/spinner.component";
import { ModalIconComponent } from "../modal-icon/modal-icon.component";

@Component({
  selector: 'toast',
  imports: [SpinnerComponent, ModalIconComponent],
  templateUrl: './toast.component.html',
  styleUrl: './toast.component.scss'
})
export class ToastComponent {
  items!: WritableSignal<ToastItem[]>;
  constructor(public toast: ToastService) {
    this.items = toast.getItems();
  }

}
export interface ToastItem {
  style: 'success'|'warning'|'error'|'info'|'loading',
  type: 'static'|'timed',
  message: string,
  time: number,
  elapsed: number
}
